exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".emailDealerModal__container___8_FWd > div > div > div {\n  padding: 0 20px; }\n\n.emailDealerModal__container___8_FWd > div {\n  top: 50%;\n  transform: translateY(-50%); }\n", ""]);

// exports
exports.locals = {
	"container": "emailDealerModal__container___8_FWd"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"sourceMap":false,"minimize":true,"importLoaders":2,"localIdentName":"[name]__[local]___[hash:base64:5]"}!./node_modules/sass-loader/lib/loader.js?{"includePaths":["./src"]}!./src/containers/AdDetailsPage/AdDetailsPageMobile/EmailDealerModal/emailDealerModal.scss
// module id = 4541
// module chunks = 6